module.exports = __webpack_public_path__ + "img/VL_02_03.ad194b8e.png";